import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DrawerState {
    currentUserState: {
        id: string;
        companyName: string;
        companyTitle: string;
        companyId: number;
        customerId: number;
        customerNo: string;
        type: number;
        status: boolean;
        name: string;
        surName: string;
        email: string;
        phoneCountry: string;
        phoneNumber: string;
        selectedUserInfo: number;
        isUsedMealCard?: boolean | null;
        fastMaxVal?: number | null;
    };
}
const initialState: DrawerState = {
    currentUserState: {
        id: '',
        companyName: '',
        companyTitle: '',
        companyId: 0,
        customerId: 0,
        customerNo: '',
        type: 0,
        status: false,
        name: '',
        surName: '',
        email: '',
        phoneCountry: '',
        phoneNumber: '',
        selectedUserInfo: 0,
        isUsedMealCard: null,
        fastMaxVal: null
    },
};

const currentUserStateSlice = createSlice({
    name: 'currentUserState',
    initialState,
    reducers: {
        setCurrentUserState: (state, action: PayloadAction<DrawerState['currentUserState']>) => {
            state.currentUserState = action.payload;
        },
        setSelectedCompanyId: (state, action: PayloadAction<number>) => {
            state.currentUserState.companyId = action.payload;
        },
        setGetWallet: (state, action: PayloadAction<number>) => {
            state.currentUserState.companyId = action.payload;
        },
    },
});

export const { setCurrentUserState, setSelectedCompanyId } = currentUserStateSlice.actions;

export default currentUserStateSlice.reducer;
